import { useNavigate } from 'react-router-dom'
import Layout from '../../components/Layout'

const steps = [
    {
        emoji: '🏦',
        title: 'Nachystaj si aspoň 3 účty',
        text: 'Najlepšie sú Nike, Tipsport a Fortuna — najväčšie SK stávkovky, kde sa tvoje stávky stratia v dave. Bez účtov na viacerých stávkovkách arbitráže podávať nemôžeš.'
    },
    {
        emoji: '🎯',
        title: 'Nezačínaj hneď so surebetmi',
        text: 'Ak si na účtoch ešte nestávkoval, určite nezačínaj surebetmi. Podaj najprv niekoľko normálnych stávok na populárne ligy — Premier League, NBA, Champions League. Môžeš pokojne podať aj záporné arbitráže (malá strata), vyzerajú prirodzene.'
    },
    {
        emoji: '🔢',
        title: 'Vždy zaokrúhľuj vklady',
        text: 'Nikdy nepodávaj za 67,92 € alebo 134,31 €. Používaj okrúhle sumy — 5 €, 10 €, 50 €, 100 €. Presné sumy sú pre stávkovky okamžite podozrivé a urýchľujú limitáciu.'
    },
    {
        emoji: '⭐',
        title: 'Vyberaj populárne zápasy — žlté bodky',
        text: 'Žltá bodka v softvéri znamená top zápas kde stávkuje veľa ľudí. Tvoja stávka sa tam stratí v dave. Exotické ligy kde stávkuje málokto sú rizikové — stávkovka si ťa všimne okamžite.'
    },
    {
        emoji: '🎲',
        title: 'Sem-tam live alebo kombinovaná stávka',
        text: 'Bežní hráči hrajú live stávky a kombinácie. Ak stávkuješ len prematch singles, vyzeráš podozrivo. Občas hoď live stávku alebo dvojzápas — kľudne aj mimo arbitráž.'
    },
    {
        emoji: '📱',
        title: 'Zapni Telegram notifikácie',
        text: 'Nemusíš sedieť celý deň pri obrazovke. Nastav si notifikácie cez tlačidlo Upozorniť a dostaneš správu priamo na telefón keď sa objaví arbitráž podľa tvojich filtrov.'
    },
    {
        emoji: '📖',
        title: 'Prečítaj celý návod',
        text: 'Návod obsahuje všetko — ako sa vyhnúť limitácii, čo robiť pri zamietnutom tikete, aký vklad urobiť, a oveľa viac. 10 minút čítania ti môže ušetriť mesiace frustrácie.',
        link: '/navod.html',
        linkText: 'Otvoriť celý návod →'
    },
]

const GettingStarted = () => {
    const navigate = useNavigate()

    return (
        <Layout>
            <div
                className="container-fluid text-white"
                style={{ minHeight: 'calc(100vh - 56px)', background: '#161616', paddingBottom: '60px' }}
            >
                <div style={{ maxWidth: '640px', margin: '0 auto', padding: '32px 16px 0' }}>

                    {/* Header */}
                    <div className='mb-4'>
                        <div style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '6px' }}>
                            👋 Vitaj na Arbitrage.sk
                        </div>
                        <div className='text-secondary' style={{ fontSize: '0.95rem', lineHeight: 1.6 }}>
                            Pred prvou stávkou si prečítaj tieto kroky. Pomôžu ti vyhnúť sa rýchlej limitácii a začať správne.
                        </div>
                    </div>

                    {/* Steps */}
                    <div className='d-flex flex-column gap-3'>
                        {steps.map((step, i) => (
                            <div
                                key={i}
                                className='p-4 rounded-4'
                                style={{ backgroundColor: '#222222' }}
                            >
                                <div className='d-flex align-items-start gap-3'>
                                    <div style={{ fontSize: '1.5rem', minWidth: '32px', lineHeight: 1.2 }}>
                                        {step.emoji}
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: 500, marginBottom: '6px', fontSize: '1rem' }}>
                                            {step.title}
                                        </div>
                                        <div className='text-secondary' style={{ fontSize: '0.88rem', lineHeight: 1.65 }}>
                                            {step.text}
                                        </div>
                                        {step.link && (
                                            <a
                                                href={step.link}
                                                target='_blank'
                                                rel='noreferrer'
                                                className='d-inline-block mt-2'
                                                style={{ color: '#1186f0', fontSize: '0.88rem', textDecoration: 'none' }}
                                            >
                                                {step.linkText}
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Kontakt */}
                    <div
                        className='p-4 rounded-4 mt-3'
                        style={{ backgroundColor: '#222222', borderLeft: '3px solid #1186f0' }}
                    >
                        <div style={{ fontWeight: 500, marginBottom: '6px' }}>
                            💬 Máš otázku?
                        </div>
                        <div className='text-secondary' style={{ fontSize: '0.88rem', lineHeight: 1.65 }}>
                            Napíš nám na Instagram{' '}
                            <a
                                href='https://instagram.com/arbitrage.sk'
                                target='_blank'
                                rel='noreferrer'
                                style={{ color: '#1186f0', textDecoration: 'none' }}
                            >
                                @arbitrage.sk
                            </a>
                            {' '}
                            alebo Whatsapp <a
                                href='https://wa.me/421917782762'
                                target='_blank'
                                rel='noreferrer'
                                style={{ color: '#1186f0', textDecoration: 'none' }}
                            >+421 917 782 762</a>
                            {' '}— odpovieme rýchlo. Si tu nový, pomôžeme ti začať.
                        </div>
                    </div>

                    {/* CTA späť */}
                    <div className='mt-4 d-flex justify-content-center'>
                        <button
                            onClick={() => navigate('/prematch/arbitrage')}
                            className='btn text-white px-5 py-2'
                            style={{ backgroundColor: '#1186f0', border: 'none', borderRadius: '10px', fontSize: '0.95rem' }}
                        >
                            Rozumiem, ísť na arbitráže →
                        </button>
                    </div>

                </div>
            </div>
        </Layout>
    )
}

export default GettingStarted